import { Grid as MGrid, GridProps } from '@mui/material'

export const Grid: React.FC<GridProps> = (props) => {
  return <MGrid {...props} />
}
